import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding-left: 2rem;
    padding-right: 2rem;
    display: flex;
    flex-wrap: wrap;        
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5rem;  
    margin-bottom: 5rem;s        
`;
